import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GolfIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GolfIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.3387 15.4854C18.7707 15.2765 18.5698 14.7442 18.5703 14.3519C18.5706 14.114 18.646 13.5334 19.3391 13.2804C21.0612 12.6452 22.0894 11.5242 22.0894 10.2815C22.0894 7.93435 18.7774 6.82586 16.3893 6.76618C16.3823 6.76598 16.3751 6.76595 16.368 6.76602C12.6468 6.8086 9.90264 7.4621 7.94909 8.23157V6.50797L12.2563 4.89277C12.7621 4.70313 12.762 3.98517 12.2563 3.79553L7.5689 2.03776C7.18633 1.89425 6.77724 2.17764 6.77724 2.58638V8.74879C4.52397 9.85939 2.08984 11.9021 2.08984 14.383C2.08984 19.7832 11.0007 22 16.738 22C19.232 22 22.0894 20.9218 22.0894 18.4845C22.0894 17.2419 21.0612 16.1208 19.3387 15.4854ZM7.94905 3.43191L10.3818 4.3442L7.94905 5.25649V3.43191ZM16.7379 20.8282C7.54468 20.8282 3.26165 16.9823 3.26165 14.383C3.26165 13.0543 4.40495 11.3791 6.7772 10.0692V12.956C6.14975 13.2255 5.60535 13.7002 5.60535 14.383C5.60535 15.6213 7.27301 16.1408 8.53497 16.1408C9.81498 16.1408 11.4646 15.612 11.4646 14.383C11.4646 13.1447 9.79693 12.6252 8.53497 12.6252C8.33611 12.6252 8.14002 12.6368 7.94905 12.6584V9.49785C10.031 8.60303 12.825 7.97976 16.3706 7.93792C18.1684 7.98491 20.9175 8.81482 20.9175 10.2815C20.9175 11.0018 20.1573 11.7296 18.9354 12.1803C17.9887 12.5258 17.3997 13.3574 17.3984 14.3504C17.3971 15.3642 17.9998 16.2414 18.9335 16.585C20.1573 17.0364 20.9175 17.7643 20.9175 18.4845C20.9175 20.1646 18.4783 20.8282 16.7379 20.8282ZM8.53497 13.7971C9.5726 13.7971 10.2927 14.204 10.2927 14.383C10.2927 14.5591 9.58596 14.969 8.53497 14.969C7.49734 14.969 6.7772 14.5621 6.7772 14.383C6.7772 14.2069 7.48398 13.7971 8.53497 13.7971Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.3942 12.6253C13.425 12.6253 12.6365 13.4138 12.6365 14.383C12.6365 15.3523 13.425 16.1408 14.3942 16.1408C15.3635 16.1408 16.152 15.3523 16.152 14.383C16.152 13.4138 15.3635 12.6253 14.3942 12.6253ZM14.3942 14.969C14.0711 14.969 13.8083 14.7061 13.8083 14.383C13.8083 14.06 14.0712 13.7971 14.3942 13.7971C14.7173 13.7971 14.9801 14.06 14.9801 14.383C14.9801 14.7061 14.7173 14.969 14.3942 14.969Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default GolfIcon;
